import { medusaClient } from "../config"
import {StoreGetProductsParams} from "@medusajs/medusa";

export type ProductFilter = {
  [key: string]: {[key: string]:string[]}
}

export const getProductFilters = async (collectionId?:string): Promise<ProductFilter> => {
  const filter:StoreGetProductsParams = { limit: 1000 }
  if(collectionId)
    filter["collection_id"] = [collectionId]
  const products = await medusaClient.products
      .list(filter)
      .then(({ products }) => products)

  const options: ProductFilter = {}
  for (const product of products) {
    product.options.forEach((option) => {
      if(typeof options[option.title] === "undefined")
        options[option.title] = {}
      option.values.forEach((value) => {
        if(!Object.keys(options[option.title]).includes(value.value))
          options[option.title][value.value] = [product.id]
        else if(!options[option.title][value.value].includes(product.id))
          options[option.title][value.value].push(product.id)
      })
    })
  }

  return options
}
